<template>
  <section id="comingsoon">
      <ComingSoon />
  </section>
</template>

<script>
import ComingSoon from "@/components/ComingSoon";
import LayoutDefault from "../layouts/LayoutDefault";

export default {
  created() {
    this.$emit("update:layout", LayoutDefault);
      this.$root.$emit('closenav', false);
  },
  components: {
    ComingSoon
  }
};
</script>

<style scoped lang="scss">
#comingsoon {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: table;
    margin: 0 auto;
  }
  h1 {
    font-size: 2.5em;
    text-transform: uppercase;
  }
}
</style>